module.exports = __webpack_public_path__ + "img/moon.79225fa0.svg";